import { File as FileIcon, X } from 'react-feather'

import * as S from './AttachmentChips.styles'
import type { ChatAttachment } from './useFileAttachments'

interface AttachmentChipsProps {
  attachments: ChatAttachment[]
  onRemove: (id: string) => void
}

const formatFileSize = (bytes: number) => {
  if (bytes < 1024) return `${bytes} B`
  const kb = bytes / 1024
  if (kb < 1024) return `${parseFloat(kb.toFixed(1))} KB`
  return `${parseFloat((kb / 1024).toFixed(1))} MB`
}

// Files staged for the next message, shown on top of the message box. Each chip
// can be removed until the message is sent.
export const AttachmentChips = ({ attachments, onRemove }: AttachmentChipsProps) => (
  <S.ChipRow>
    {attachments.map(({ id, file, previewUrl }) => (
      <S.Chip key={id}>
        {previewUrl ? (
          <S.Thumb src={previewUrl} alt="" />
        ) : (
          <S.TypeIcon>
            <FileIcon size={14} />
          </S.TypeIcon>
        )}
        <S.ChipName title={file.name}>{file.name}</S.ChipName>
        <S.ChipSize>{formatFileSize(file.size)}</S.ChipSize>
        <S.RemoveButton
          type="button"
          aria-label={`Remove ${file.name}`}
          onClick={() => onRemove(id)}
        >
          <X size={12} />
        </S.RemoveButton>
      </S.Chip>
    ))}
  </S.ChipRow>
)
